import { PRODUCTS } from '@/utilities/constants/game';
import { useStore } from '@/store/useStore';

export const GAME_CLIENT_ERRORS = {
  USER_IS_NOT_ELIGIBLE: 'USER_IS_NOT_ELIGIBLE',
  NO_VALID_GEO_APPROVAL: 'NO_VALID_GEO_APPROVAL',
  GEOLOCATION_PRODUCT_MISMATCH: 'GEOLOCATION_PRODUCT_MISMATCH',
  TIME_LIMIT_REACHED: 'TIME_LIMIT_REACHED',
} as const;

export type GameClientErrorPopup = {
  popupName: string;
  popupMessage: string;
};

const getRuntimeProduct = () => {
  try {
    return (
      useStore.getState?.().runtime?.product ?? process.env.PRODUCT ?? 'casino'
    );
  } catch {
    return process.env.PRODUCT ?? 'casino';
  }
};

const PRODUCT =
  getRuntimeProduct()?.toLowerCase() === PRODUCTS.POKER ? 'poker' : 'casino';

export const GAME_CLIENT_ERROR_POPUPS: Record<string, GameClientErrorPopup> = {
  [GAME_CLIENT_ERRORS.USER_IS_NOT_ELIGIBLE]: {
    popupName: "You can't play right now",
    popupMessage: `Follow these tips and try again:\n
      1. Make sure you're in a state that allows online ${PRODUCT} \n
      2. Confirm you've finished signing up \n
      3. See if you've been excluded or suspended`,
  },
  [GAME_CLIENT_ERRORS.NO_VALID_GEO_APPROVAL]: {
    popupName: 'Location not found',
    popupMessage:
      'Sorry, we checked a few times. Go home and try another game.',
  },
  [GAME_CLIENT_ERRORS.TIME_LIMIT_REACHED]: {
    popupName: 'Time limit',
    popupMessage: 'Time limit has been reached.',
  },
};

export const getGameClientErrorPopup = (
  errorCode?: string | null,
): GameClientErrorPopup | undefined =>
  errorCode ? GAME_CLIENT_ERROR_POPUPS[errorCode] : undefined;
